export class VendorStatement {
  public StatementDate: Date;
  public TotalAmount: Number;
  public Currency: string;
  public AttachedFileName: string;
  public JSSICustomerNumber: string;
  public GPVID: string;
  public FileData: string;
}



// WEBPACK FOOTER //
// ./src/app/models/VendorStatement.ts